import { render, staticRenderFns } from "./held_sales.vue?vue&type=template&id=34aff208"
import script from "./held_sales.vue?vue&type=script&lang=js"
export * from "./held_sales.vue?vue&type=script&lang=js"
import style0 from "./held_sales.vue?vue&type=style&index=0&id=34aff208&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports